var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Component from '@arco-design/web-react/es/Select/select';
import cx from 'classnames';
import { useConfigContext } from '../config-provider';
import { getPopupContainerSelectHelper } from '../utils/observer';
// @ts-ignore
import IconDown from '@arco-design/web-react/icon/react-icon/IconDown';
var renderFixedBottomChoice = function (fixedChoice, prefixCls) {
    return (fixedChoice.length ?
        fixedChoice.map(function (option) { return (React.createElement(Component.Option, { key: option, value: option, className: prefixCls + "-option-fixed" }, option)); }) :
        null);
};
var Select = function (props, ref) {
    var className = props.className, _a = props.arrowIcon, arrowIcon = _a === void 0 ? React.createElement(IconDown, null) : _a, getPopupContainer = props.getPopupContainer, children = props.children, _b = props.fixedBottomChoice, fixedBottomChoice = _b === void 0 ? [] : _b, mode = props.mode, customTagOnTop = props.customTagOnTop, passedTriggerProps = props.triggerProps;
    var _c = React.useState('bottom'), triggerPos = _c[0], setTriggerPos = _c[1];
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-select";
    var triggerCls = prefixCls + "-trigger";
    var triggerPosCls = prefixCls + "-trigger-" + triggerPos;
    var getPopupContainerCombine = function (node) {
        getPopupContainer && getPopupContainer(node);
        return getPopupContainerSelectHelper(node, setTriggerPos);
    };
    if (mode === 'tags' && customTagOnTop && 'inputValue' in props) {
        var inputValue = props.inputValue;
        var prefixClsCustomTagOnTop = prefixCls + "-option-custom-tag-on-top";
        return (React.createElement(Component, __assign({}, props, { mode: 'multiple', ref: ref, getPopupContainer: getPopupContainerCombine, arrowIcon: arrowIcon, className: cx(className, prefixCls, triggerPosCls), triggerProps: __assign(__assign({}, passedTriggerProps), { className: cx(triggerCls, passedTriggerProps === null || passedTriggerProps === void 0 ? void 0 : passedTriggerProps.className) }), size: "large" }),
            inputValue ? (React.createElement(Component.Option, { key: inputValue, value: inputValue, className: cx(prefixClsCustomTagOnTop) }, inputValue)) : null,
            children,
            renderFixedBottomChoice(fixedBottomChoice, prefixCls)));
    }
    return (React.createElement(Component, __assign({}, props, { ref: ref, getPopupContainer: getPopupContainerCombine, arrowIcon: arrowIcon, className: cx(className, prefixCls, triggerPosCls), triggerProps: __assign(__assign({}, passedTriggerProps), { className: cx(triggerCls, passedTriggerProps === null || passedTriggerProps === void 0 ? void 0 : passedTriggerProps.className) }), size: "large" }),
        children,
        renderFixedBottomChoice(fixedBottomChoice, prefixCls)));
};
var ForwardRefSelect = React.forwardRef(Select);
var SelectComponent = ForwardRefSelect;
SelectComponent.Option = Component.Option;
SelectComponent.OptGroup = Component.OptGroup;
SelectComponent.displayName = 'Select';
export default SelectComponent;
//# sourceMappingURL=index.js.map